/* ============================================================================
   Birthday / anniversary animation.

   The confetti lives in <Header/>, which only knows the signed-in user's own
   date of birth - so it never fired when the birthday belonged to a colleague.
   The list of today's birthdays comes back with the dashboard data, so the
   dashboards announce it here and the header plays the animation.
   ========================================================================== */
export const CELEBRATE_EVENT = "app:celebrate";

export const celebrate = () => {
  window.dispatchEvent(new CustomEvent(CELEBRATE_EVENT));
};

export default celebrate;
